import styled from 'styled-components'

export const RowStyled = styled.div`
    transition: outline 150ms ease;
    border-top-width:1px;
    border-top-color: ${p => p.theme.colors.secondary};
    ${p => p.theme.alignItems && `align-items: ${p.theme.alignItems}` };
    ${p => p.theme.justifyContent && `justify-content: ${p.theme.justifyContent}` };
    background-color: inherit;
    transition: background-color 250ms ease;
    position: relative;
    display:flex;
    height:100%; // fill up rows to section height in builder

    &:before {
        content: '';
        display: ${p => p.hover ? 'block' : 'none'};
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(248,215,218,0.6);
        z-index: 100;
    }

    ${p => p.inlineCSS && p.inlineCSS}
`;

export const LeftCol = styled.div`
    margin-top: 7px;
    position: absolute;
    display:flex;
    flex-direction: column;
    align-items:center;
    justify-content:space-between;
    left: -40px;
    top: -2px;
    width:50px;
    bottom: 0;
    border-top-left-radius: 10px;
    font-family: Nunito;
    color:white;
    font-weight:800;


`


export const Empty = styled.div`
    height: 300px;
`

export const HeaderColumn = styled.div`
    height:1px;
    position: relative;
    display: flex;
    justify-content: center;
    margin-bottom: 5px;
`

export const Top = styled.div``
export const Center = styled.div``
export const Bottom = styled.div`
    padding-bottom:0.3rem;
`

export const IconWrapper = styled.div`
    position: relative;
    width: 25px;
    height: 25px;
    background-color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-bottom:5px;

    transition: background-color 250ms ease;
    &:hover {
    background-color: #eee;
    }
`

export const SettingsIcon = styled.em`
    color: #777;
    font-size: 20px;
`
export const AddRowIcon = styled.em`
    color: #777;
    font-size: 16px;
`

export const DeleteWrapper = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 101;
`